const RELEASE = "1.0.0"

export default RELEASE
